var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBtnIcon02On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.8125C17 3.64862 17.0577 3.45773 17.42 3.21396C17.816 2.94757 18.4707 2.7019 19.4169 2.50672C21.0872 2.16216 23.3743 2.02978 26 2.00462V21.1635C23.7622 21.1278 21.3764 21.2085 19.4425 21.5676C18.5577 21.7318 17.7109 21.964 17 22.3031V3.8125ZM15 3.8125C15 3.64862 14.9423 3.45773 14.58 3.21396C14.184 2.94757 13.5293 2.7019 12.5831 2.50672C10.9128 2.16216 8.62569 2.02978 6 2.00462V21.1635C8.23781 21.1278 10.6236 21.2085 12.5575 21.5676C13.4423 21.7318 14.2891 21.964 15 22.3031V3.8125ZM17.5442 24.28C17.0831 24.5671 17 24.8046 17 25H30V5H28V22.1875V23.2192L26.9688 23.187C24.4847 23.1094 21.8228 23.1598 19.8075 23.534C18.7916 23.7226 18.0286 23.9784 17.5442 24.28ZM14.4558 24.28C14.9169 24.5671 15 24.8046 15 25H2V5H4V22.1875V23.2192L5.03123 23.187C7.51532 23.1094 10.1772 23.1598 12.1925 23.534C13.2084 23.7226 13.9714 23.9784 14.4558 24.28ZM4 3H1C0.447715 3 0 3.44772 0 4V26C0 26.5523 0.447715 27 1 27H31C31.5523 27 32 26.5523 32 26V4C32 3.44772 31.5523 3 31 3H28V1V0H27C23.9505 0 21.1103 0.11529 19.0128 0.547965C17.9707 0.762942 17.018 1.07391 16.3036 1.55459C16.1982 1.62548 16.0967 1.70118 16 1.78177C15.9033 1.70118 15.8018 1.62548 15.6964 1.55459C14.982 1.07391 14.0293 0.762942 12.9872 0.547965C10.8897 0.11529 8.0495 0 5 0H4V1V3Z",
    fill: "#25426D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnIcon02On);
export default __webpack_public_path__ + "static/media/btn_icon02_on.669accdff62b49ad022b38182ac4b83b.svg";
export { ForwardRef as ReactComponent };